import { Component, OnInit } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { Validators, FormControl, FormGroup } from '@angular/forms';
import { MatSelectChange } from '@angular/material/select';
import { BaseFilterComponent } from '../base-filter.component';
import { StringFilterType } from '../../../../../core/services/api-services';
import { FilterType } from '../../../../../core/enums/filter-type';
import { Filter } from '../../../../../core/models/filter';

@Component({
  selector: 'app-string-filter',
  templateUrl: './string-filter.component.html',
  styleUrls: ['./string-filter.component.scss']
})
export class StringFilterComponent extends BaseFilterComponent<StringFilterType> implements OnInit {
  stringFilterType = StringFilterType;

  filterForm = new FormGroup({
    filterType: new FormControl<StringFilterType>(StringFilterType.Contains, { validators: [Validators.required], nonNullable: true },),
  });

  stringForm = new FormGroup({
    value: new FormControl<string | null>(null, { validators: [Validators.required] }),
  });

  filterOptions = this.getFilterOptions();
  currentFilter = new BehaviorSubject<StringFilterType>(StringFilterType.Contains);
  filterType: FilterType = FilterType.String;

  constructor() {
    super();
  }

  ngOnInit(): void {
    this.currentValue
      .unsubscribeOnDestroy(this)
      .subscribe(value => {
        if (value) {
          this.filterChanged.emit({ filter: value, filterType: this.filterType, propertyName: this.propertyName });
          this.activeFilterField = value !== null;

          this.filterTypeControl.setValue(value.filterType);
          this.stringControl.setValue(value.values[0]);
        }
      });

    if (this.initialValue) {
      this.currentValue.next(this.initialValue);
    }
  }

  clearFilter(): void {
    this.currentValue.next(null);
    this.activeFilterField = this.currentValue.value !== null;
    this.filterForm.reset();
    this.stringForm.reset();
  }

  getFilterOptions(): { value: number, translationKey: string }[] {
    const options: { value: number, translationKey: string }[] = [];

    Object.keys(StringFilterType).filter((enumVal) => !isNaN(Number(enumVal))).forEach((enumVal: any) => {
      options.push({
        value: parseInt(enumVal, 10),
        translationKey: `GridTable.Filter.StringFilters.${StringFilterType[enumVal]}`
      });
    });

    return options;
  }

  onFilterChange($event: MatSelectChange): void {
    this.currentFilter.next($event.value as StringFilterType);
  }

  onSubmit($event): void {
    // Trigger form validation for untouched fields
    this.stringForm.markAllAsTouched();

    if (this.stringForm.valid) {
      const model: Filter<StringFilterType> = {
        filterType: this.filterTypeControl.value,
        values: [this.stringControl.value, null] as any[],
        name: this.propertyName
      };

      this.currentValue.next(model);
    }
    else {
      $event?.stopPropagation();
    }
  }

  onCancel(): void {
  }

  get stringControl(): FormControl {
    return this.stringForm.controls.value as FormControl;
  }

  get filterTypeControl(): FormControl {
    return this.filterForm.controls.filterType as FormControl;
  }
}
